<template>
    <div class="flex flex-col md:flex-row md:items-end w-full justify-between">
        <div >
            <router-link :to="{ name: 'adminClientsAdd' }" class="btn btn--red-1" v-if="profile.isSharpAdmin()">
                <i class="far fa-plus text-lg mr-2"></i> Add Client
            </router-link>
        </div>
        <div class="mt-4 md:mt-0 ml">
            <div class="flex border border-blue-gray rounded-3xl pl-5 pr-5 py-1 py-2 items-center">
                <input @change="reloadClients" v-model="searchString" type="text" placeholder="Search Client"
                       class="w-full md:w-56 text-sm font-light bg-transparent outline-none"> <i
                    class="far fa-search text-blue-gray"></i>
            </div>
        </div>
    </div>

    <div class="bg-white shadow-100 rounded-xl mt-4" >
        <div class="equipment-row grid-cols-1 md:grid-cols-9 items-center hidden md:grid py-3 px-7">
            <div class="style-title-1 md:col-span-2">
                Account Name
            </div>
            <div class="style-title-1 md:col-span-2">
                Grouped Account
            </div>
            <div class="style-title-1 md:col-span-2">
                Client Account No
            </div>

            <div class="text-center style-title-1">
                Users
            </div>
            <div class="text-center style-title-1 md:col-span-2">
                Action
            </div>
        </div>

        <div v-for="client in clients"
             class="equipment-row grid grid-cols-1 md:grid-cols-9 items-center py-5 px-7" :key="client.id">
            <div class="py-1 flex md:col-span-2 justify-between">
                <div class="style-title-1 w-1/2 text-right mr-3 md:hidden">
                    Account Name:
                </div>
                <div>
                    <div @click="goToClientDevices(client)" class="text-red cursor-pointer">
                        {{ client.name }}
                    </div>
                </div>
            </div>
            <div class="py-1 flex md:col-span-2 justify-between">
                <div class="style-title-1 w-1/2 text-right mr-3 md:hidden">
                    Grouped Account:
                </div>
                <div>
                    {{ client.group_name }}
                </div>
            </div>

            <div class="py-1 flex md:col-span-2 justify-between">
                <div class="style-title-1 w-1/2 text-right mr-3 md:hidden">
                    Account No:
                </div>
                <div>
                    {{ client.account_number }}
                </div>
            </div>

            <div class="py-1 flex md:col-span-1 justify-between md:justify-center">
                <div class="style-title-1 w-1/2 text-right mr-3 md:hidden">
                    Users:
                </div>
                <div class="md:text-center md:w-full">
                    {{ client.users_count }}
                </div>
            </div>

            <div class="md:text-center mt-4 md:mt-0 md:col-span-2">
                <toggle-menu>
                    <div @click="goToClientEdit(client)" class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray" v-if="profile.isSharpAdmin()">
                        <i class="fal fa-cog text-lg mr-3 "></i> Client Settings
                    </div>

                    <div @click="goToClientDevices(client)" class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray">
                        <i class="fal fa-print text-lg mr-3 "></i> Client Devices
                    </div>

                    <div @click="goToClientUsers(client)" class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray">
                        <i class="fal fa-user-circle text-lg mr-3 "></i> Client Users
                    </div>
                </toggle-menu>
            </div>
        </div>
    </div>

    <div class="text-center mt-5" :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <div class="text-center mt-8" :class="{hidden: !partial}">
        <a @click="loadMore" class="btn">Load More</a>
    </div>


</template>

<script charset="utf-8">

import Loading from './Loading.vue';
import ToggleMenu from './ToggleMenu.vue';
import Vuex from 'vuex';

export default {
    name: 'ClientGrid',
    props: ['title', 'toAddress'],
    data() {
        return {
            curPage: 0,
            loading: false,
            searchString: ''
        }
    },
    computed: {
        ...Vuex.mapGetters('accounts', {
            clients: 'clients',
            partial: 'partial'
        }),
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
    },

    created() {
        this.loading = true;
        this.clearClients();
        this.getClients().finally(() => {
            this.loading = false;
        });
    },
    components: {
        Loading,
        ToggleMenu
    },

    methods: {
        ...Vuex.mapMutations('accounts', {
            setSelectedClient: 'setSelectedClient',
            clearClients: 'clearClients',
        }),
        ...Vuex.mapActions('accounts', {
            getClients: 'getClients'
        }),
        loadClients(){
            this.loading = true;
            this.getClients({ page: this.curPage, searchString: this.searchString}).finally(() => {
                this.loading = false;
            });
        },
        loadMore(){
            this.curPage++;
            this.loadClients();
        },
        reloadClients(){
            this.curPage = 0;
            this.loadClients();
        },
        goToClientEdit(client){
            this.setSelectedClient(client);
            if(this.profile.isGroupAdmin()){
                this.$router.push({ name: 'groupAdminClientsEdit', params: { clientID: client.id } });
            }else{
                this.$router.push({ name: 'adminClientsEdit', params: { clientID: client.id } });
            }

        },
        goToClientUsers(client){
            this.setSelectedClient(client);
            if(this.profile.isGroupAdmin()){
                this.$router.push({ name: 'groupAdminUser', params: { clientID: client.id } });
            }else{
                this.$router.push({ name: 'adminUser', params: { clientID: client.id } });
            }
        },
        goToClientDevices(client){
            this.setSelectedClient(client);
            if(this.profile.isGroupAdmin()){
                this.$router.push({ name: 'groupAdminDevice', params: { clientID: client.id } });
            }else{
                this.$router.push({ name: 'adminDevice', params: { clientID: client.id } });
            }
        },
        /*
        select(equipment) {
            this.$emit('select', equipment);
        }*/
    }
}
</script>
